export default {
  editSubscriptionTitle: {
    description: "Not found title",
    defaultMessage: "Subscription already exists.",
    id: "Result.editSubscriptionTitle",
  },
  editSubscriptionMessage: {
    description: "Not found message",
    defaultMessage:
      "Sorry, seems you already have a subscription. Buying another subscription is not possible at the moment.",
    id: "Result.editSubscriptionMessage",
  },
};
